import CountryCodeSelector from '@/components/CountryCodeSelector/index';
import { COLORS } from '@/helpers/constants/theme';
import { useUnregisteredCustomerContext } from '@/views/UnregisteredCustomer/context/UnregisteredCustomerContext';

export function PhoneStep() {
  const {
    phoneNumber,
    setPhoneNumber,
    errors,
    setErrors,
    isSearching,
    onPhoneSubmit,
    hoverBackground,
    hoverHandlers,
    textColor,
  } = useUnregisteredCustomerContext();

  return (
    <div className='space-y-4'>
      <div className='space-y-2'>
        <div className='flex w-full gap-0'>
          <div className='w-28 flex-shrink-0 bg-gray-50'>
            <CountryCodeSelector />
          </div>
          <input
            className='w-full rounded-r-md border border-l-0 border-gray-300 px-2 py-2 text-sm'
            placeholder='Phone Number'
            value={phoneNumber}
            onInput={(e) => {
              setPhoneNumber((e.target as HTMLInputElement).value);
              setErrors((prev) => ({ ...prev, phoneNumber: undefined }));
            }}
          />
        </div>
        {errors.phoneNumber && <h6 className='!text-red-600'>{errors.phoneNumber}</h6>}
      </div>

      <button
        onClick={onPhoneSubmit}
        {...hoverHandlers}
        disabled={isSearching}
        className={`w-full rounded-lg px-4 py-3 font-semibold transition-colors ${
          isSearching ? 'cursor-not-allowed' : 'cursor-pointer'
        }`}
        style={{
          backgroundColor: isSearching ? COLORS.DISABLED_DARK : hoverBackground,
          color: isSearching ? COLORS.DISABLED_LIGHT : textColor,
        }}
      >
        {isSearching ? 'Checking...' : 'Continue'}
      </button>
    </div>
  );
}
